// @ts-nocheck

import { createSelector } from 'reselect';

import { GRChipStatuses, type GRRoundBetsBetState } from '../types/chip';
import { type GRRound, type GRRoundState } from '../types/round';
import { GRRoundUserStatuses } from '../types/user';

import { selectGRRounds } from './rules';
import { selectGRUserProgress } from './user';

const emptyObj = {};
const emptyArray: [] = [];

const getRoundIdFromProps = (_, { roundId }): GRRound => roundId;

export const selectGRUserRoundByRoundId = createSelector(
  [getRoundIdFromProps, selectGRUserProgress],
  (roundId, progress): GRRoundState | null => progress?.[roundId] ?? emptyObj,
);

export const selectGRBetsFromRound = createSelector(
  [selectGRUserRoundByRoundId],
  (userRound): Array<GRRoundBetsBetState> => userRound?.bets ?? emptyArray,
);

export const selectGRPointsFromRound = createSelector(
  [selectGRUserRoundByRoundId],
  (userRound): number => userRound?.points ?? 0,
);

export const selectGRRoundWonAmountFromRound = createSelector(
  [selectGRUserRoundByRoundId],
  (userRound): number => userRound?.wonAmount ?? 0,
);

export const selectGRPointsBySumFromRound = createSelector([selectGRBetsFromRound], (bets): number =>
  bets.reduce((acc, curr) => acc + (curr.status === GRChipStatuses.WON && curr.counted ? curr.points ?? 0 : 0), 0),
);

export const selectIsGRRoundLocked = createSelector(
  [selectGRUserRoundByRoundId],
  (userRound): boolean => userRound?.status === GRRoundUserStatuses.LOCKED,
);

export const selectIsGRRoundWon = createSelector(
  [selectGRUserRoundByRoundId],
  (userRound): boolean => userRound?.status === GRRoundUserStatuses.WON,
);

export const selectGRSpecificRuleFromRound = createSelector(
  [getRoundIdFromProps, selectGRRounds],
  (roundId, rounds) => rounds[roundId] ?? emptyObj,
);

export const selectMaxPointsGRSpecificRule = createSelector(
  selectGRSpecificRuleFromRound,
  (specificRule) => specificRule.requiredPoints,
);

export const selectMinStakeMultiplicatorGRSpecificRule = createSelector(
  selectGRSpecificRuleFromRound,
  (specificRule) => specificRule.minStakeMultiplier,
);

export const selectMaxStakeMultiplicatorGRSpecificRule = createSelector(
  selectGRSpecificRuleFromRound,
  (specificRule) => specificRule.maxStakeMultiplier,
);
